import styled from 'styled-components';
import palette from 'lib/styles/palette';
import useMasterKidsCreator from 'hooks/contract/useMasterKidsCreator';
import Loading from 'components/common/Loading';
import NotiModal from 'components/common/NotiModal';

const MasterKidsCreator = ({ closeModal, masterId }) => {
  const { registerForm, errors, createMasterKidsMutation, onChange, onAdd } =
    useMasterKidsCreator({ closeModal, masterId });

  if (createMasterKidsMutation.error?.response.status === 500)
    return (
      <NotiModal closeModal={closeModal} msg="서버 오류가 발생했습니다" fontL />
    );

  return (
    <MasterKidsCreatorBlock>
      <div className="title">Master Kids ID 생성</div>
      <div className="input-wrapper">
        {createMasterKidsMutation.isLoading ||
        createMasterKidsMutation.error?.response.status === 401 ? (
          <Loading style={{ marginTop: 15, marginBottom: 15 }} />
        ) : (
          <>
            <StyledInput
              type="text"
              placeholder="ID"
              name="userId"
              value={registerForm.username}
              onChange={onChange}
            />
            {errors.userId && <div className="err-msg">{errors.userId}</div>}
            <StyledInput
              type="password"
              placeholder="password"
              name="password"
              value={registerForm.password}
              onChange={onChange}
            />
            {errors.password && (
              <div className="err-msg">{errors.password}</div>
            )}
          </>
        )}
      </div>
      {errors.serverError && (
        <div className="err-msg" style={{ marginTop: 10, marginLeft: 0 }}>
          {errors.serverError}
        </div>
      )}
      <div className="button-wrapper">
        <StyledButton onClick={closeModal}>닫기</StyledButton>
        <StyledButton blue onClick={onAdd}>
          생성
        </StyledButton>
      </div>
    </MasterKidsCreatorBlock>
  );
};

export default MasterKidsCreator;

const MasterKidsCreatorBlock = styled.div`
  margin-top: 20px;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  padding-bottom: 30px;

  .title {
    font-size: 1.1rem;
    font-weight: bold;
  }

  .input-wrapper {
    width: 250px;
    margin-top: 1rem;

    input + input {
      margin-top: 0.5rem;
    }
  }

  .err-msg {
    margin-left: 5px;
    margin-top: 0.2rem;
    font-size: 10px;
    color: red;
  }

  .err-msg + input {
    margin-top: 0.5rem;
  }

  .button-wrapper {
    margin-top: 25px;
  }
`;

const StyledInput = styled.input`
  width: 100%;
  border: solid 1px #dfdfdf;
  border-radius: 5px;
  background: #fff;
  padding: 5px;
  font-size: 12px;
  &::placeholder {
    color: #c6c6c6;
  }
`;

const StyledButton = styled.button`
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  background: ${props => (props.blue ? palette.theme[3] : palette.theme[0])};
  color: #fff;
  cursor: pointer;
  & + & {
    margin-left: 10px;
  }
  :hover {
    background: ${palette.theme[2]};
  }
`;
